// Standard library imports
import React from 'react';
// Internal module imports
import TabsComponent from '../../../components/Tabs/Tabs';
import HourlyCost from './HourlyCost';
import CapacityContent from './Capacity';
import PriceContent from './Price';

const BiddingInfoContent = ({ data }) => {
    let tabs = [
        {
            name: 'Settlement (€)',
            component: (
                <>
                    <HourlyCost data={data.hourlyData} />
                </>
            ),
        },
        {
            name: 'Bidding Price (€)',
            component: (
                <>
                    <PriceContent data={data.price} />
                </>
            ),
        },
        {
            name: 'Bidding Capacity (MW)',
            component: (
                <>
                    <CapacityContent data={data.capacity} />
                </>
            ),
        },
    ];

    return (
        <div className={'ventilation'} style={{ display: 'flex' }}>
            <TabsComponent selectedIndex={0} tabs={tabs} />
        </div>
    );
};

export default BiddingInfoContent;
